/**
 * List Item component
 * @author Liwei Yeh <liwei.yeh@adasasistemas.com>
 */

// CSS Style for this module
import styles from './listItem.module.scss';

/**
 * Interface for ListItem props
 */
interface ListItemProps {
	/**
	 * Title/name of the listed item
	 */
	title: string;
	/**
	 * Content of the listed item
	 */
	content?: React.ReactNode;
}
/**
 * Display a list of results to users surfacing key information.
 * @param {ListItemProps} Prop
 * @returns  a styled list item
 */
export const ListItem = ({ title, content = '' }: ListItemProps) => {
	return (
		<>
			<div className={styles.title}>{title}</div>
			<div className={styles.content}>{content}</div>
		</>
	);
};
